// extracted by mini-css-extract-plugin
module.exports = {"shortcuts":"_2CeGr","shortcutLink":"_1URDb"};